// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FilePdfTwoToneSvg from "@fishx/icons-svg/es/asn/FilePdfTwoTone";
import FishxIcon from '../components/FishxIcon';

var FilePdfTwoTone = function FilePdfTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FilePdfTwoToneSvg
  }));
};

FilePdfTwoTone.displayName = 'FilePdfTwoTone';
export default React.forwardRef(FilePdfTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FilePdfTwoTone.js
// module id = 2734
// module chunks = 0